var Account = {

  form: function () {
    return $('#user-account-settings')
  },

  toggleRow: function (row, checked) {
    if (checked) {
      row.show();
    } else {
      row.hide();
      row.find('input').prop('checked', false);
    }
  },

  toggleCenter: function () {
    var row = Account.form()
      .find('div[data-center=' + $(this).val() + ']');
    Account.toggleRow(row, $(this).is(':checked'))
  },

  toggleGroupSubscription: function () {
    var row = Account.form()
      .find('div[data-center=astri]');
    Account.toggleRow(row, $(this).is(':checked'))
  },

  init: function () {
    var allCenters = Account.form()
      .find('input[type=checkbox]')
      .filter('[name=centers],[name=groupSubscription]');

    allCenters.on('input', function () {
      $('#subscription-block').toggle(allCenters.is(':checked'));
    });

    allCenters
      .filter('[name=centers]')
      .on('input', Account.toggleCenter)
      .trigger('input');

    allCenters
      .filter('[name=groupSubscription]')
      .on('input', Account.toggleGroupSubscription)
      .trigger('input');
  }
};

$(function () {
  Account.init();
});
